import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class SpendbackStatusFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
            >
                <option value="">ALL</option>
                <option value="10">PENDING</option>
                <option value="20">COMPLETED</option>
                <option value="30">REVIEW</option>
                <option value="40">EXPIRED</option>
                <option value="50">CANCELED</option>
                <option value="90">FAILED</option>
            </select>
        );
    }
}
